import { Component, OnInit } from '@angular/core';
import { AuthenService } from 'src/app/services/authen.service';
import { AngularFireAuth} from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import Swal from 'sweetalert2'
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  correo:string;
  contrasena:string;
  coclear=0
  to
  name
  subject
  text
  constructor(private authService:AuthenService,private db:AngularFirestore, private auth:  AngularFireAuth) { }

  ngOnInit() {
  }

  login(){
   this.authService.authentificathion(this.correo,this.contrasena)
  }

  cambiarEstado(){
    this.coclear=1
  }
  redigirPlaystore(){
    window.open('https://play.google.com/store/apps/details?id=com.turrisystem.appsalud2&hl=es-419')
  }

  envioCorreo(){
    this.db.collection('mensajeria').add({
      to:this.to,
      name:this.name,
      message:{
        subject:this.subject,
        text:this.text,
        
      }
    }).then(()=>{
      Swal.fire('Gracias por su sugerencia u observacion..','Ha sido Registrada.','success')
      this.to=null
      this.name=null
      this.subject=null
      this.text=null
    })
  }
}
